import { useCurrentCompany } from '@/hooks/useCurrentCompany'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import helpService from '@/lib/services/helpService'

export function useEmailClient() {
  const currentUser = useCurrentUser()
  const currentCompany = useCurrentCompany()

  return {
    open: () =>
      helpService.openEmailClient({
        currentUser,
        currentCompany,
      }),
  }
}
